export default class UserCostPool {
    public id: string = "";
    
    public costPoolId: string = "";
    
    public userId: string = "";
    
    public isUserCostPool: true = true;
}